import { directLoginApis, userAuthenticationAPI } from "../../constants/apis/apiEndpoints";
import axios from "axios";
import { translator } from "../../constants/actionTypes";

//Api for demand login verification
export const verificationForDemandLogin = async (data) => {
  const resStats = await axios
    .post(`${translator?.baseURL}${directLoginApis?.verifyDemandLogin}`, data)
    .then((response) => response)
    .catch((error) => error);
  return resStats;
};

//API for direct login token for AAD user / IDP User
export const getTokenForDirectLoginAAD = async (data) => {
  const resStats = await axios
    .post(`${translator?.baseURL}${directLoginApis?.getDemandLoginToken}`, data)
    .then((response) => response)
    .catch((error) => error);
  return resStats;
};

//Api for local user IDP call with IDP API url
export const getTokenForLocalUserFromIDP = async (data) => {
  let apiEndpoint = data?.apiUrl;
  if (!apiEndpoint.endsWith("/")) {
    apiEndpoint = apiEndpoint + "/";
  }
  delete data?.apiUrl;

  return axios
    .post(`${apiEndpoint}${userAuthenticationAPI?.fetchLocalUserAccessToken}`, data)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      return error;
    });
};
